import { isBrowser } from '../ports/browser-ports';

/** The two `Storage` areas `oidc-client-ts` can be pointed at. */
export type WebStorageKind = 'local' | 'session';

/**
 * Reads a web storage area, or `undefined` where there is not one to read.
 *
 * Two separate failures, both non-obvious:
 * - outside a browser `window` is not merely undefined, it is *undeclared*, so
 *   `window === undefined` raises a `ReferenceError`. Only `typeof` — which
 *   {@link isBrowser} wraps — can test an undeclared binding.
 * - the property access itself throws `SecurityError` when the origin is denied
 *   storage (enterprise policy, Safari's blocked third-party cookies, some
 *   private modes). Feature-detecting `window` is not enough.
 *
 * Callers treat `undefined` as "no storage tier", which leaves `oidc-client-ts`
 * on its own in-memory default rather than failing to construct.
 */
export function resolveWebStorage(kind: WebStorageKind): Storage | undefined {
  if (!isBrowser()) return undefined;

  try {
    return kind === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return undefined;
  }
}
